import { render, staticRenderFns } from "./FormPageAdPlacement.vue?vue&type=template&id=7d3cfe35&"
import script from "./FormPageAdPlacement.vue?vue&type=script&lang=js&"
export * from "./FormPageAdPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3cfe35')) {
      api.createRecord('7d3cfe35', component.options)
    } else {
      api.reload('7d3cfe35', component.options)
    }
    module.hot.accept("./FormPageAdPlacement.vue?vue&type=template&id=7d3cfe35&", function () {
      api.rerender('7d3cfe35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AdPlacement/form/FormPageAdPlacement.vue"
export default component.exports